export function pick<T>(key: keyof T, obj: T) {
  return obj[key];
}
